import { FormFieldTypes } from "../../../data/formFieldType";
import ProductList from "../components/ProductList";

export const SGBPApplicationFormData = {
  name: "SGBPApplicationFormData",
  initialState: {
    companyName: "",
    companyUEN: "",
    typeOfCompany: null,
    mainContactPerson: "",
    mainPhoneNumberID: null,
    mainContactPhone: "",
    mainContactEmail: "",
    serviceCategory: null,
    subCategory: null,
    productType: null,
    applicantRole: null,
    productCateloueName: "",
    productCateloueFileName: null,
    productPictureName: "",
    productPictureFileName: null,
    productsGreenFeatures: "",
    nameOfManufacturer: "",
    addressOfManufacturer: "",
    sameAsManufacturer: "",
    nameOfManufacturingPlant: "",
    addressofManufacturingPlant: "",
    placeofManufacturing: "",
    criteria:null
  },

  formFields: [
    // {
    //   Field_Name: "companyInformationTitle",
    //   fieldType: FormFieldTypes.MAINFORMTITLE,
    //   fieldSetting: {
    //     formTitle: "Company Information",
    //   },
    //   style: {
    //     containerCss: "col-lg-12 mb-3 text-left",
    //   },
    // },

    {
      id: "companyName",
      lable: "Company Name",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable: true,
      },
      // validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },
    {
      id: "companyUEN",
      lable: "Company UEN ",
      Field_Name: "Company UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyUEN",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable: true,
      },
      // validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    {
      id: "typeOfCompany",
      lable: "Type of Company",
      Field_Name: "Type of Company",
      fieldType: FormFieldTypes.SELECT,
      dataField: "typeOfCompany",
      fieldSetting: {
        placeholder: "",
        options: [],
        isDisable: true,
      },
      // validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-4" },
    },

    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },

    {
      id: "applicationInformationTitle",
      Field_Name: "applicationInformationTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      fieldSetting: {
        formTitle: "Application Information",
      },
      style: {
        containerCss: "col-lg-12 mb-3 text-left mt-4",
      },
    },

    {
      id: "mainContactPerson",
      lable: "Main Contact Person ",
      Field_Name: "Main Contact Person",
      fieldType: FormFieldTypes.SELECT,
      dataField: "mainContactPerson",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },

    {
      id: "mainContactPhone",
      lable: "Main Contact Phone ",
      Field_Name: [" Main Phone Number"],
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["mainPhoneNumberID", "mainContactPhone"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
        isDisable: true,
      },
      // validation: [{ type: "require" }, { type: "number" }],
      style: { containerCss: "col-md-6 mb-3" },
    },
    {
      id: "mainContactEmail",
      lable: "Main Contact Email Address ",
      Field_Name: "Main Contact Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mainContactEmail",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
        isDisable: true,
      },
      // validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-4" },
    },
    {
      id: "applicantRole",
      lable: "Applicant’s Role",
      Field_Name: "Applicant’s Role",
      subLabelName: "?",
      isSubEvent: true,
      fieldType: FormFieldTypes.SELECT,
      dataField: "applicantRole",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3 applicant-role-label" },
    },

    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },
    /* =========================
       SERVICE DETAILS
    ========================== */
    {
      id: "serviceDetailsTitle",
      Field_Name: "serviceDetailsTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      fieldSetting: {
        formTitle: "Product Details",
      },
      style: {
        containerCss: "col-lg-12 mb-3 text-left mt-4",
      },
    },

    {
      id: "serviceCategory",
      lable: "Category (L1) ",
      Field_Name: "Category (L1)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "serviceCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
         isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },

    {
      id: "subCategory",
      lable: "Sub Category (L2)",
      Field_Name: "Sub Category (L2)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "subCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
         isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },
    {
      id: "productType",
      lable: "Type (L3)",
      Field_Name: "Type (L3)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "productType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
         isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },

    {
      id: "searchEmailButton",
      fieldType: FormFieldTypes.COMPONENT,
      additionalComponent: <ProductList />,
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
    {
      id: "productCateloueName",
      lable: "Product Catalogue (please upload in PDF, JPG, JPEG, PNG. Max 5MB)",
      Field_Name: "Product Catalogue",
      fieldType: FormFieldTypes.FILE,
      dataField: "productCateloueName",
      fieldSetting: {
        // presentFileName: null,
        placeholder: "",
        isDownloadable: false,
        acceptedFiles: ".jpg,.png,.jpeg,.pdf",
        imageCrop: true,
        viewImage: false,
        maxFileSizeInKB: 5000,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "productPictureName",
      lable: "Product Picture (please upload in JPG, JPEG, PNG. Max 5MB)",
      Field_Name: "Product Picture",
      fieldType: FormFieldTypes.FILE,
      dataField: "productPictureName",
      fieldSetting: {
        // presentFileName: null,
        placeholder: "",
        isDownloadable: false,
        acceptedFiles: ".jpg, .png, .jpeg",
        imageCrop: true,
        viewImage: true,
        maxFileSizeInKB: 5000,
      },
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    {
      id: "productsGreenFeatures",
      lable: "Products Green Features",
      Field_Name: "Products Green Features",
      subLabelName: "(e.g. low VOC level, energy saving properties, recyclability, usage of recycled content, etc.)",
      fieldType: FormFieldTypes.INPUT,
      dataField: "productsGreenFeatures",
       fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-12 mb-4 product-feature" },
    },


    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },
    /* =========================
       SERVICE DETAILS
    ========================== */
    {
      id: "serviceDetailsTitle",
      Field_Name: "serviceDetailsTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      fieldSetting: {
        formTitle: "Manufacturer Details",
      },
      style: {
        containerCss: "col-lg-12 mb-3 text-left mt-4",
      },
    },
    {
      id: "nameOfManufacturer",
      lable: "Name of Manufacturer",
      Field_Name: "Name of Manufacturer",
      fieldType: FormFieldTypes.INPUT,
      dataField: "nameOfManufacturer",
       fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-4" },
    },
    {
      id: "addressOfManufacturer",
      lable: "Address of Manufacturer ",
      Field_Name: "Address of Manufacturer ",
      fieldType: FormFieldTypes.INPUT,
      dataField: "addressOfManufacturer",
       fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-4" },
    },
    {
      id: "sameAsManufacturer",
      lable: "Same as Manufacturer",
      Field_Name: "Same as Manufacturer",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "sameAsManufacturer",
      style: {
        containerCss: "col-12 mt-3",
      },
    },
    {
      id: "nameOfManufacturingPlant",
      lable: "Name of Manufacturing Plant",
      Field_Name: "Name of Manufacturing Plant",
      fieldType: FormFieldTypes.INPUT,
      dataField: "nameOfManufacturingPlant",
       fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-4" },
    },
    {
      id: "addressofManufacturingPlant",
      lable: "Address of Manufacturing Plant",
      Field_Name: "Address of Manufacturing Plant",
      fieldType: FormFieldTypes.INPUT,
      dataField: "addressofManufacturingPlant",
       fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-4" },
    },
    {
      id: "placeofManufacturing",
      lable: "Place of Manufacturing ",
      Field_Name: "Place of Manufacturing ",
      fieldType: FormFieldTypes.SELECT,
      dataField: "placeofManufacturing",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },

    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },

     {
      id: "criteria",
       lable: "Criteria Selected",
      Field_Name: "Criteria Selected",
      fieldType: FormFieldTypes.SELECT,
      dataField: "criteria",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      // validation: [{ type: "require" }],
       style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3 sgbp-select",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};




  // {
  //     id: "criteriaSelected",
  //     lable: "Criteria Selected",
  //     Field_Name: "Criteria Selected",
  //     fieldType: FormFieldTypes.SELECT,
  //     dataField: "criteriaSelected",
  //     fieldSetting: {
  //       placeholder: "Select",
  //       options: [],
  //     },
  //     style: {
  //       containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
  //     },
  //   },